import { Publication } from '../models'
import { getDateFormattedSmall } from '../helpers'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomText,
  CustomHeaderText,
  PublicationMovileViewColumn,
  PublicationUrlLanguagesColumn
} from 'src/components'

const publicationListColumns: ColumnsType<Publication> = [

  {
    title: () => <CustomHeaderText text='footPrint.Name' />,
    responsive: ['sm'],
    sorter: (a: Publication, b: Publication) => a.name.length - b.name.length,
    render: (_, publication) => <CustomText label={publication.name} strong />
  },
  {
    title: () => <CustomHeaderText text='ValidateDeposits.DateCreated' isCentered />,
    responsive: ['sm'],
    align: 'center',
    sorter: (a: Publication, b: Publication) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, publication) => {
      return (
        <CustomText
          label={getDateFormattedSmall(publication.created)}
          className='centered'
        />
      )
    }
  },
  {
    title: () => <CustomHeaderText text='Publications.Languages' isCentered />,
    responsive: ['sm'],
    sorter: (a: Publication, b: Publication) => a.urls.length - b.urls.length,
    render: (_, publication) => <PublicationUrlLanguagesColumn urls={publication.urls} />
  },
  /* Mobile View */
  {
    title: () => <CustomHeaderText text='Publications.Singular' />,
    responsive: ['xs'],
    sorter: (a: Publication, b: Publication) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, publication) => <PublicationMovileViewColumn publication={publication} />
  },
]

export default publicationListColumns
